
import { useConf } from "../../context/account/paramsAccount";

import { useOfflineMode } from "../../context/horsLigne/modeHorsLigneContext";
import { useToken } from "../../context/connexion/token/token";

interface DescriptionUser {
    isConnected: boolean;
    modalIsOpen: boolean;
    openModal: (selectedValue: boolean) => void;
    deconnexion: (userDeco: any) => void;
}
const ModalUser: React.FC<DescriptionUser> = ({ isConnected, modalIsOpen, openModal, deconnexion }) => {
    const {  toggleOfflineMode } = useOfflineMode();
    const { token }: any = useToken()

    const { conf, setConf }: any = useConf()

    const saveId = () => {
        toggleOfflineMode();

    };


    return (
        <div className="right_header">


        </div>
    )
}

export default ModalUser